import {
  createSlice,
  PayloadAction
} from "@reduxjs/toolkit";
import {
  TestCaseIncoming,
  TestCaseIncomingHistory
} from "../../types/testCaseIncomingTypes";

const initialState = {
  selectedTestCaseIncoming: {
    name: "",
    methodId: 0,
  } as TestCaseIncoming,
  selectedTestCaseIncomingHistory: {
    id: 0,
    testCaseIncomingId: 0,
    isExportedToTestRail: false,
    request: "",
    response: "",
    runDate: "",
    status: ""
  } as TestCaseIncomingHistory
}

const testCaseIncomingSlice = createSlice({
  name: "scenarioSlice",
  initialState,
  reducers: {
    setSelectedTestCaseIncoming: (state, action: PayloadAction<TestCaseIncoming>) => {
      state.selectedTestCaseIncoming = action.payload;
    },
    deleteSelectedTestCaseIncoming(state) {
      state.selectedTestCaseIncoming = {
        name: "",
        methodId: 0,
      };
      state.selectedTestCaseIncomingHistory = {
        id: 0,
        testCaseIncomingId: 0,
        isExportedToTestRail: false,
        request: "",
        response: "",
        runDate: "",
        status: ""
      }
    },
    setSelectedTestCaseIncomingHistory: (state, action: PayloadAction<TestCaseIncomingHistory>) => {
      state.selectedTestCaseIncomingHistory = action.payload;
    },
    deleteSelectedTestCaseIncomingHistory(state) {
      state.selectedTestCaseIncomingHistory = {
        id: 0,
        testCaseIncomingId: 0,
        isExportedToTestRail: false,
        request: "",
        response: "",
        runDate: "",
        status: ""
      }
    },
  }
});

export const {
  setSelectedTestCaseIncoming,
  deleteSelectedTestCaseIncoming,
  setSelectedTestCaseIncomingHistory,
  deleteSelectedTestCaseIncomingHistory
} = testCaseIncomingSlice.actions;

export default testCaseIncomingSlice.reducer;